import { WebApiService } from '../../../plugins/webApiService'
import { SendRequestModel } from '../../../plugins/models/SendRequestModel'
import WsResponseModelT from '../../../schema-builder/server/models/WsResponseModelT';
import UserResponse from '../../../users/base/i-service/models/UserResponse';

/**
 * * Сервис для управления пользователями
 */
export default class UsersService {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	
	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
	}

	/**
	 * * Получить текушего пользователя
	 */
	async GetCurrentUser() {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'UsersService',
			Method: 'GetCurrentUser',
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	/**
	 * * Получить текушего пользователя
	 */
	async getCurrentUserAsync(): Promise<UserResponse> {
		return new Promise<UserResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'UsersService',
				Method: 'GetCurrentUser',
				Callback: (response: WsResponseModelT<UserResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as UserResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}